import { ListagemItem } from "../../types"

export const checarNumeroMaximoDeItens = (listaItens: ListagemItem[], quantidadeModulos: number, id?: number, value?: number) => {
  if (id) {
    const quantidadeItem = value || (listaItens?.find(item => item.componente_id === id)?.quantidade || 0);
    return quantidadeItem > quantidadeModulos;
  }

  const totalItens = listaItens.reduce((acc, curr) => acc + curr.quantidade, 0);
  return listaItens?.some(item => item.quantidade > quantidadeModulos) || totalItens > quantidadeModulos;
}